import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import WorkAreaItem from 'modules/locations/components/WorkAreaItem'
import { WorkAreaNode } from 'modules/locations/hooks/useWorkAreas'

interface PropsWorkArea {
  locationId: number
  unarchiveWorkAreas: NonNullable<WorkAreaNode>[]
  canManageWorkArea: boolean
  canAddSpace: boolean
}

const WorkAreasItem = ({
  locationId,
  unarchiveWorkAreas,
  canManageWorkArea,
  canAddSpace,
}: PropsWorkArea) => {
  const workAreas = unarchiveWorkAreas.map((workArea) => {
    return (
      <WorkAreaItem
        workArea={workArea}
        key={`${workArea.id}${workArea.name}`}
        locationId={locationId}
        workSpacesCount={workArea?.workSpacesConnection?.totalCount || 0}
        workAreaMapUrl={workArea?.workAreaMap?.image?.url || undefined}
        canManageWorkArea={canManageWorkArea}
        canAddSpace={canAddSpace}
      />
    )
  })
  return (
    <Box paddingBottom="s24" gap="s24">
      {workAreas}
    </Box>
  )
}

export default observer(WorkAreasItem)
